<template>
    <div ref="draggable"
         :class="classes.draggable">
        <!-- Draggable header -->
        <div class="draggable__header">
            <slot name="header" />
            
            <!-- Draggable controller -->
            <div :class="classes.controller"
                 @mousedown.prevent="draggableStart">
                <slot name="controller" />
            </div>
        </div>

        <!-- Draggable content -->
        <slot />

        <!-- Draggable resizer -->
        <div v-if="resizeable"
             class="abs depth-10 b-0 l-0 wh-1 cursor-nesw-resize"
             @mousedown.prevent="resizeableStart">
            <icon name="resizer" />
        </div>
    </div>
</template>

<script>
export default {
  name: 'Draggable',

  props: {
    resizeable: { type: Boolean, default: false },

    size: { type: Number, default: 1 },

    minWidth: { type: Number, default: 32 },
    minHeight: { type: Number, default: 32 },
    
    maxWidth: { type: Number, default: null },
    maxHeight: { type: Number, default: null }
  },

  data() {
    return {
      draggable: false,

      deltaX: null,
      deltaY: null
    }
  },

  computed: {
    classes() {
      return {
        draggable: {
          'draggable abs depth-100 f-col r-0 b-0': true,
          'cursor-drag': this.draggable
        },
        controller: {
          'cursor-grab': !this.draggable
        }
      }
    },

    draggableMaxWidth() {
      return this.maxWidth || document.documentElement.clientWidth * 0.98
    },

    draggableMaxHeight() {
      return this.maxHeight || document.documentElement.clientHeight * 0.98
    }
  },
  
  mounted() {
    this.resizeable && this.changeSize(this.minWidth * this.size, this.minHeight * this.size)
  },

  methods: {
    draggableStart(event) {
      const { x, y } = event
      const { left, top } = this.$refs.draggable.getBoundingClientRect()
      
      this.deltaX = x - left
      this.deltaY = y - top

      this.draggable = true

      document.addEventListener('mousemove', this.move)
      document.addEventListener('mouseup', this.draggableEnd)
    },
    
    draggableEnd() {
      this.draggable = false

      document.removeEventListener('mousemove', this.move)
      document.removeEventListener('mouseup', this.draggableEnd)
    },

    move(event) {
      const { x, y } = event
      const { width, height } = this.$refs.draggable.getBoundingClientRect()

      const left = x - this.deltaX
      const top = y - this.deltaY
      const clientWidth = document.documentElement.clientWidth
      const clientHeight = document.documentElement.clientHeight

      const newLeft = left + width >= clientWidth 
        ? clientWidth - width 
        : left <= 0 ? 0 : left

      const newTop = top + height > clientHeight 
        ? clientHeight - height 
        : top <= 0 ? 0 : top

      this.$refs.draggable.style.left = newLeft + 'px'
      this.$refs.draggable.style.top = newTop + 'px'
    },

    resizeableStart(event) {
      const { x, y } = event
      const { left, bottom, width } = this.$refs.draggable.getBoundingClientRect()

      this.deltaX = x - left
      this.deltaY = bottom - y

      this.$refs.draggable.style.right = document.documentElement.clientWidth - (left + width) + 'px'
      this.$refs.draggable.style.left = 'auto'

      document.addEventListener('mousemove', this.resize)
      document.addEventListener('mouseup', this.resizeableEnd)
    },

    resizeableEnd() {
      document.removeEventListener('mousemove', this.resize)
      document.removeEventListener('mouseup', this.resizeableEnd)
    },

    resize(event) {
      const { x, y } = event
      const { width, height, left, bottom } = this.$refs.draggable.getBoundingClientRect()
      
      const _width = width + (left - x + this.deltaX)
      const _height = height + (y + this.deltaY - bottom)

      const newWidth = _width < this.minWidth 
        ? this.minWidth
        : _width > this.draggableMaxWidth 
          ? this.draggableMaxWidth 
          : _width

      const newHeight = _height < this.minHeight 
        ? this.minHeight
        : _height > this.draggableMaxHeight 
          ? this.draggableMaxHeight 
          : _height 

      this.width = newWidth
      this.height = newHeight

      this.$refs.draggable.style.width = newWidth + 'px'
      this.$refs.draggable.style.height = newHeight + 'px'
    },

    changeSize(width, height) {
      this.$refs.draggable.style.width = width + 'px'
      this.$refs.draggable.style.height = height + 'px'
    }
  }
}
</script>